export const tiposConsultasAntecedentesTypes = {
  simples: 'SIMPLES',
  unificar: 'UNIFICAR',
  juntar: 'JUNTAR',
};
